import { render, staticRenderFns } from "./xtabs.vue?vue&type=template&id=9860dc84&scoped=true&"
import script from "./xtabs.vue?vue&type=script&lang=js&"
export * from "./xtabs.vue?vue&type=script&lang=js&"
import style0 from "./xtabs.vue?vue&type=style&index=0&id=9860dc84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9860dc84",
  null
  
)

export default component.exports